import IconButton from "./IconButton";

export default IconButton;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/IconButton/index.tsx